import { BookOpenTextIcon } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { Flex, Typography } from "antd";
import { TrackedFatButton } from "components/FatButton/FatButton";
import { useAntTheme } from "hooks/useAntTheme";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useProjectNavigate } from "../hooks/useProjectNavigate";

interface projectDetailsInterface {
  projectId: string;
  projectType: string;
  storyboardStatus: string;
  instanceId: string;
  storyboardId: string;
}

interface ProjectSettingsWaitingProps {
  projectDetails: projectDetailsInterface;
}

export const ProjectSettingsWaiting: React.FC<ProjectSettingsWaitingProps> = ({
  projectDetails,
}) => {
  const t = useTranslate();
  const navigate = useNavigate();
  const { getProjectRoute } = useProjectNavigate();
  const { theme } = useAntTheme();

  const route =
    projectDetails.storyboardStatus === "Reviewing"
      ? getProjectRoute({
          projectId: projectDetails.projectId,
          storyboardId: projectDetails.storyboardId,
          instanceId: projectDetails.instanceId,
          subRoute: "script",
        })
      : projectDetails.storyboardStatus === "Generating"
        ? getProjectRoute({
            projectId: projectDetails.projectId,
            storyboardId: projectDetails.storyboardId,
            instanceId: projectDetails.instanceId,
            subRoute: "script/generating",
          })
        : "";

  return (
    <Flex vertical align="center">
      <Typography.Text
        style={{
          fontSize: 36,
          fontFamily: "Montserrat, sans-serif",
          marginTop: 0,
          marginBottom: 16,
        }}
      >
        {t("media.projects.detail.toDoNext")}
      </Typography.Text>
      <TrackedFatButton
        type={"default"}
        titleFontSize={20}
        contentFontSize={12}
        title={t("media.projects.projectMenu.editStoryboard")}
        content={t("media.projects.projectMenu.reviewContentOfVideo")}
        icon={<BookOpenTextIcon size={44} weight="duotone" />}
        iconSize={55}
        iconColor={theme.colorPrimary}
        style={{
          width: "100%",
          flex: "1",
          maxWidth: "275px",
          minHeight: "140px",
        }}
        onClick={() => {
          navigate(route);
        }}
      />
    </Flex>
  );
};
